import NumberInput from 'athena/components/number-input';
import t from 'react-translate';

type TimeZoneOffsetInputProps = {
  value: number;
  min: number;
  max: number;
  disabled?: boolean;
  onChange: (value: number) => void;
};

const TimeZoneOffsetInput = ({
  value,
  min,
  max,
  disabled,
  onChange,
}: TimeZoneOffsetInputProps) => {
  return (
    <div className='d-flex align-items-center'>
      <span>±</span>
      <div className='d-flex align-items-center'>
        <NumberInput
          className='mx-1'
          name='expression'
          min={min}
          max={max}
          disabled={disabled}
          value={value}
          showTooltipOnDisabledUp
          tooltipTextOnDisabledUp={t.MENTORING_PROGRAMS.TIME_ZONE_OFFSET_INPUT.TOOLTIP_TEXT_ON_DISABLED_UP()}
          onChange={onChange}
        />
      </div>
      <span>{t.TIME.HOURS()}</span>
    </div>
  );
};

export default TimeZoneOffsetInput;
